
import React from 'react';
import HeaderComponent from './commonComponent/HeaderComponent';

function Terms() {
  return (
    <>

        <HeaderComponent title="Terms" />
   
        <div className="container-fluid py-5">
        <div className="container py-5">
            <div className="row">

                <h1>Terms of Use</h1>
                
                </div>
                <br/>
                <div className="row">

                <p>General</p>

                <p>This website is owned by Yash Jain & Associates and is for informational purposes only. By accessing any content on this website, the user acknowledges that the information provided:</p>
                <p>(a) does not amount to advertising or solicitation, and
(b) is meant only for his/her understanding about the activities of Yash Jain & Associates.</p>

<p>All content provided on this website has been checked for accuracy. However, Yash Jain & Associates does not accept any responsibility for any action taken based on the content on this website. Further, views/opinions/articles/information/discussion and other such content provided on the website, whether by Yash Jain & Associates or third parties, do not constitute legal advice or opinion. The views expressed in the articles, Top Discussions, Featured Articles, and other such content on this website represent the personal views of the author(s) and do not, in any manner, constitute the views of the firm Yash Jain & Associates.</p>

<p>Any dispute arising out of or related to information contained on this website shall be subject to the jurisdiction of Gwalior Courts only.</p>

<p>Electronic links to this website are prohibited without the express consent of Yash Jain & Associates. Links to third-party resources or websites are provided only for informational purposes and do not in any manner constitute endorsement or expression of any association with such third parties. Any mention of Yash Jain & Associates by such third-party resources or websites shall not be construed as an endorsement of any activity, views, opinions, or any content of such parties by Yash Jain & Associates. Yash Jain & Associates shall not be held responsible for non-functioning of any link on this website due to any reason whatsoever. Yash Jain & Associates is not liable for any commission or omission attributable to use of or reliance on content in any other website of a first party for which links are provided on this website.</p>

<p>Privacy and Security</p>

<p>Data, personal or otherwise, submitted on this website will be protected and shall not be shared without the consent of the person whose data is proposed to be shared. This website contains pages where personal information such as name and email address is sought for the purpose of fulfilling requests for sending newsletters or sharing other knowledge-based resources. This information may be shared with third parties for such limited purposes, and providing such personal data indicates acceptance by the user for such sharing. Information sent by users without being solicited does not stand protected from disclosure to third parties. Such unsolicited information and/or emails sent to Yash Jain & Associates will not be considered confidential and do not create an attorney-client relationship with Yash Jain & Associates.</p>

<p>This website may use cookies, thereby accessing information such as Internet Protocol (IP) address, browser type, and access time. Such information is used for knowing more about the kind of information that users may require by analyzing the traffic to the website.</p>

<p>Copyright</p>

<p>The copyright in the content on this website is owned by Yash Jain & Associates. Copyright in respect of resources such as articles is owned by Yash Jain & Associates unless otherwise expressly stated. Copying, reproducing, scanning, storing, distributing, or transmitting in any form or by any means, including electronic, is prohibited unless permitted by Yash Jain & Associates in writing.</p>
                
                </div>
        </div>
        </div>

    

    </>
  );
}

export default Terms;
